import React from "react";

const Header = () => {
    return (
        <header style={{marginBottom : '50px'}}>
            <div className="site-content">
                {/* Preloader start */}
                {/*<div className="loader-mask">
                    <div className="loading-window">
                        <div className="loader">
                            <div className="loader-inner line-scale">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>*/}
                {/* Preloader end */}
            </div>
        </header>
    );
};

export default Header;